import * as React from "react";
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { FrameInfo } from './pages/FrameInfo';
import { About } from './pages/About';
import Navbar from "./components/Navbar";
import { Api } from "./pages/Api";
import { Login } from "./pages/Login";
import { Profile } from "./pages/Profile";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import { Morphs } from "./pages/Morphs";
import NotFound from "./components/NotFound";
import { AuthProvider } from './context/AuthContext';
import { ConfigProvider } from './context/ConfigContext';
import AuthRoute from "./AuthRoute";
import AuthModRoute from "./AuthModRoute";
import { Activity } from "./pages/Activity";
import { Sketches } from "./pages/Sketch";
import { Moderation } from "./pages/Moderation";
import AuthAdminRoute from "./AuthAdminRoute";
import { Portal } from "./pages/Portal";
import { PageContextProvider } from './context/PageContext';
import AProtectedPageRoute from "./AProtectedPageRoute";
import { Unavailable } from "./pages/Unavailable";

function App() {
	const client = new QueryClient();
	return (
		<div className="App">
			<QueryClientProvider client={client}>
				<ConfigProvider isTesting={false}>
					<AuthProvider>
						<PageContextProvider>
							<Router>
								<div id="content">
									<header>
										<div className="title">

										</div>
									</header>
									<div className="app-layout">
										<Navbar />
										<main className="page-content">
											<Routes>
												<Route path="/" element={<Home />}/>
												<Route element={<AProtectedPageRoute pageKey="activity"/>} >
													<Route path="/activity" element={<Activity />} />
												</Route>
												<Route element={<AProtectedPageRoute pageKey="morphs"/>} >
													<Route path="/morphs" element={<Morphs />} />
												</Route>
												<Route element={<AProtectedPageRoute pageKey="sketches"/>} >
													<Route path="/sketches" element={<Sketches />} />
												</Route>
												<Route path="/frameinfo" element={<FrameInfo />} />
												<Route path="/about" element={<About />} />
												<Route path="/api" element={<Api />} />
												<Route path="/login" element={<Login />} />
												<Route element={<AuthRoute />}>
													<Route path="/profile" element={<Profile />} />
												</Route>
												<Route element={<AuthModRoute />}>
													<Route path="/moderation" element={<Moderation />} />
												</Route>
												<Route element={<AuthAdminRoute />}>
													<Route path="/portal" element={<Portal />} />
												</Route>
												<Route path="/unavailable" element={<Unavailable />} />
												<Route path="*" element={<NotFound />} />
											</Routes>
										</main>
									</div>
								</div>
							</Router>
						</PageContextProvider>
					</AuthProvider>
				</ConfigProvider>
			</QueryClientProvider>
		</div>
	);
}

export default App;
